<:Window on:resize="resize()" />
<Slide :slide :i>

    <div class="media-outer">
        <video ref:video loop muted playsinline>
            {{#if slide.mp4}}
            <source src="{{ media(slide.mp4) }}" type="video/mp4">
            {{/if}}
        </video>
    </div>

    <div class="slide__text slide__text--1 slide__text--interactive step">
        <p class="slide__text-inner">{{ slide.text_list[0] }}</p>
    </div>

    <div class="chart {{ show_chart ? 'show' : '' }}">
        <div class="slide__text slide__text--2 slide__text--interactive step">
            <p class="slide__text-inner">{{ slide.text_list[1] }}</p>
        </div>

        <svg ref:svg>
            {{#if rows.length && show_chart}}
            <g transform="translate({{ pad.left }}, {{ pad.top }})" transition:fade>
                <path d="{{ line(rows) }}"></path>

                <!-- labels -->
                <circle cx="{{ x(first.year) }}" cy="{{ y(first.days) }}" r=2></circle>
                <text x="{{ x(first.year) }}" y="{{ y(first.days) }}" text-anchor="middle" dy="-15">
                    {{ first.days }} days in {{ first.year }}
                </text>

                <circle cx="{{ x(last.year) }}" cy="{{ y(last.days) }}" r=2></circle>
                <text x="{{ x(last.year) }}" y="{{ y(last.days) }}" text-anchor="middle" dy="-10">
                    {{ last.days }} days in {{ last.year }}
                </text>

            </g>
            {{/if}}
        </svg>

        {{#if show_chart}}
        <div class="legend" transition:fade>
            <p>Days with extreme high tides</p>
        </div>
        {{/if}}
    </div>

    {{#each slide.text_list.slice(2) as text_item, n }}
    <div class="slide__text slide__text--{{ n + 3 }} slide__text--interactive step">
        <p class="slide__text-inner">{{ text_item }}</p>
    </div>
    {{/each}}

</Slide>


<script>
import Slide from '../Slide.html'
import { media, noop } from '../helpers'

import { fade } from 'svelte-transitions'

import { extent } from 'd3-array'
import { csv } from 'd3-fetch'
import { line } from 'd3-shape'
import { scaleLinear } from 'd3-scale'

export default {

    components: { Slide },

    transitions: { fade },

    data() {
        return {
            pad: {top: 30, right: 50, bottom: 30, left: 50},
            width: 0,
            height: 0,
            rows: [],
        }
    },

    computed: {

        first: rows => rows[0],

        last: rows => rows[rows.length - 1],

        x: (rows, width) => scaleLinear()
            .domain(extent(rows, d => d.year))
            .range([0, width]),

        y: (rows, height) => scaleLinear()
            .domain(extent(rows, d => d.days))
            .range([height, 0]),

        line: (x, y) => line()
            .x(d => x(d.year))
            .y(d => y(d.days)),

        show_chart: ($bullet, i) => $bullet[0] === i && $bullet[1] === 1,
    },

    oncreate() {
        window.tides = this;
        this.observers = [];

        this.observers.push(this.store.observe('current_slide', current => {

            if (current === this.get('i')) {
                this.play();
            } else {
                this.pause();
            }
        }));

        csv(window.DATA.tides, d => {
            return { year: +d.year, days: +d.days };
        }).then(rows => {
            this.set({ rows });
        });

        this.observe('show_chart', show => {
            if (show) this.resize();
        }, { defer: true });

    },

    ondestroy() {
        for (let i = this.observers.length - 1; i >= 0; i--) {
            this.observers[i].cancel(); // unlisten
        }
    },

    methods: {
        play() {
            const { video } = this.refs;
            video && video.play().catch(noop);
        },

        pause() {
            const { video } = this.refs;
            video && video.pause();
        },

        resize() {
            const { width, height } = this.refs.svg.getBoundingClientRect();
            const pad = this.get('pad');
            this.set({ 
                width: width - pad.right - pad.left, 
                height: height - pad.top - pad.bottom
            });
        },
    },

    helpers: {
        media,
    }
}
</script>